<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
(function() {
  function shuffleGrid() {
    const grid = document.querySelector('[data-collection-products], .product-grid, .products-grid, .products-list');
    if (!grid) return;
    const items = Array.from(grid.children);
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      grid.insertBefore(items[j], items[i]);
    }
  }

  // רנדומלי רק אם נבחר sort_by=random
  document.addEventListener('DOMContentLoaded', function() {
    const sortSelect = document.querySelector('select[name="sort_by"]');
    if (sortSelect && sortSelect.value === 'random') shuffleGrid();
  });

  // תמיכה ב-AJAX/רענון גריד של ELLA
  const target = document.querySelector('[data-collection-products], .product-grid, .products-grid, .products-list');
  if (target) {
    const mo = new MutationObserver(function() {
      const sortSelect = document.querySelector('select[name="sort_by"]');
      if (sortSelect && sortSelect.value === 'random') shuffleGrid();
    });
    mo.observe(target, { childList: true });
  }
})();

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
